import { Form, InputNumber, Radio } from 'antd';
import type { FormInstance } from 'antd';

// חוג לכל ילד — the municipal subsidy, on a hugim box.
//
// The family pays one flat fee instead of the חוג's monthly price, and that fee
// is all the receipt carries: the חוג's real price isn't on it. So the amount
// below does double duty — it is what identifies such a charge, and it is the
// number the coach must NOT be paid a percentage of. The percentage is taken
// from the חוג's full price and spread over the חוג's months.
//
// The amount is required to switch the setting on: without it there is nothing
// to recognize a charge by, and the setting would be quietly inert. That rule is
// enforced by BoxSettingsSchema on submit rather than by a field validator here
// — a field rule fails silently when the card happens to be collapsed, whereas
// the schema path surfaces the message as a toast either way.
export function PerChildFeeFields({ form }: { form: FormInstance }) {
  const enabled = Form.useWatch('per_child_fee_enabled', form);

  // Kept MOUNTED while the setting is off (display:none, not unmounted) so antd
  // still carries the values on save and turning it back on doesn't come back
  // to empty fields.
  return (
    <>
      <Form.Item name="per_child_fee_enabled" className="mb-0">
        <Radio.Group className="flex flex-col gap-3">
          <Radio value={false}>ללא חוג לכל ילד</Radio>
          <Radio value={true}>זיהוי תשלומי חוג לכל ילד ותשלום ממחיר החוג המלא</Radio>
        </Radio.Group>
      </Form.Item>

      <div style={{ display: enabled ? undefined : 'none' }} className="mt-3">
        <Form.Item
          name="per_child_fee_amount"
          label="הסכום שמשלם הלקוח עבור חוג לכל ילד (₪)"
          className="mb-1"
          normalize={(v) => (v === '' || v == null ? null : v)}
        >
          <InputNumber min={1} max={100000} style={{ width: 160 }} dir="ltr" placeholder="200" />
        </Form.Item>
        <div className="text-small text-secondary-text mb-4">
          לפי הסכום הזה המערכת מזהה שהתשלום הוא חוג לכל ילד. יש להזין סכום אחד בלבד, זה שמופיע
          בקבלה של המשתתף.
        </div>

        <Form.Item
          name="per_child_fee_percent"
          label="אחוז ברירת מחדל לאיש צוות ראשי ממחיר החוג המלא (%)"
          className="mb-1"
        >
          <InputNumber min={0} max={100} style={{ width: 160 }} dir="ltr" />
        </Form.Item>
        <div className="text-small text-secondary-text">
          האחוז שנקבע כאן מחושב ממחיר החוג המלא, ולא מהסכום ששילם הלקוח בפועל. התשלום לאיש הצוות נפרס
          על פני חודשי החוג, כך שאיש הצוות מקבל בכל חודש בדיוק כמו על משתתף ששילם את המחיר המלא.
        </div>
      </div>
    </>
  );
}
